export default __webpack_public_path__ + "static/media/76.0ad8c2fd.jpg";